//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');
//消息类型
const messageType = (r) =>
  require.ensure([], () => r(require('@/pages/messageCenter/messageType/list.vue')), 'messageType');
//消息模板
const messageTemp = (r) =>
  require.ensure([], () => r(require('@/pages/messageCenter/messageTemp/list.vue')), 'messageTemp');
//消息任务
const messageTask = (r) =>
  require.ensure([], () => r(require('@/pages/messageCenter/messageTask/list.vue')), 'messageTask');
//用户消息
const userMessage = (r) =>
  require.ensure([], () => r(require('@/pages/messageCenter/userMessage/list.vue')), 'userMessage');

const messageCenterRouter = {
  path: '/message',
  component: index,
  children: [
    {
      path: 'messageType',
      name: 'messageType',
      component: messageType,
      meta: {
        keepAlive: true,
        title: '消息类型',
      },
    },
    {
      path: 'messageTemp',
      name: 'messageTemp',
      component: messageTemp,
      meta: {
        keepAlive: true,
        title: '消息模板',
      },
    },
    {
      path: 'messageTask',
      name: 'messageTask',
      component: messageTask,
      meta: {
        keepAlive: true,
        title: '消息任务',
      },
    },
    {
      path: 'userMessage',
      name: 'userMessage',
      component: userMessage,
      meta: {
        keepAlive: true,
        title: '用户消息',
      },
    },
  ],
};
export default messageCenterRouter;
